"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.profession.select.label': 'Choose your profession to begin onboarding:',
    'onboarding.profession.select.placeholder': '-- Select Profession --',
    'onboarding.profession.empty': 'No professions are available.',
};
